// extracted by mini-css-extract-plugin
module.exports = {"value":"intl__value___q3Oy2","label-value-vertical":"intl__label-value-vertical___57ujc"};